import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

import clsx from 'clsx'
import InfoItem from './info-item'

const useStyles = makeStyles(() => ({
  infoItem: (props) => ({
    width: `${100 / props.rowCount}%`,
  }),
  infoItemWrapper: {
    padding: 20,
    paddingTop: 0,
    display: 'flex',
    width: '100%',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
  },
}))

const Info = (props) => {
  const { infoItems = [], rowCount = 3, className, classNameContainer } = props
  const classes = useStyles({ rowCount })

  const items = infoItems.map((infoItem, index) => {
    return <InfoItem className={classes.infoItem} infoItem={infoItem} key={`infoItem${index}`} />
  }, [])

  const itemByRowCount = []
  for (let i = 0; i < items.length; i += rowCount) {
    const chunk = items.slice(i, i + rowCount)
    itemByRowCount.push((<div className={clsx(classes.infoItemWrapper, className)} key={`infoItemWrapper${i}`}>{chunk}</div>))
  }

  return (
    <div className={clsx(classes.container, classNameContainer)}>
      {itemByRowCount}
    </div>
  )
}

Info.propTypes = {
  infoItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  rowCount: PropTypes.number,
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
}

export default Info
